import { Box } from '@chakra-ui/react';
import React from 'react';
import useSnackBar from './Snackbar';
// import { sendPhoneOtpV2, verifyPhoneOtpV2 } from '../../../api/utils/api/v2/profile';
import { useMutation } from 'react-query';
import { useUser } from '../../../hooks/useUser';
import { axiosErrorHandler } from '../../../apis/axios';
import OTPModal from '../auth/OTPModal';
import PhoneEdit from './PhoneEdit';
import { signIn, verifyPhoneOtp } from '../../../apis/V2/auth';
import { useDomainConfig } from '../../../hooks/useDomainConfig';

interface Props {
	showPhoneOtpModal: boolean;
	setShowPhoneOtpModal: React.Dispatch<React.SetStateAction<boolean>>;
	updatedPhone?: string;
	setShowUpdatePhoneModal: React.Dispatch<React.SetStateAction<boolean>>;
	isClosable?: boolean;
}
const OTPVerifyModalV2 = ({ updatedPhone, showPhoneOtpModal, setShowUpdatePhoneModal, setShowPhoneOtpModal, isClosable }: Props) => {
	const { data: domainConfig, isLoading, isError } = useDomainConfig({ uiHost: window.location.host });

	const onOTPModalClose = () => {
		setShowPhoneOtpModal(false);
		refetchProfile();
	};
	const { data: profile, refetch: refetchProfile, isLoading: profileLoading } = useUser();
	const handlePhoneEditClick = () => {
		setShowPhoneOtpModal(false);
		setShowUpdatePhoneModal(true);
	};
	const snackbar = useSnackBar();
	const { mutate: sendPhoneOtpMutate, isLoading: sendPhoneOtpLoading } = useMutation(signIn, {
		onSuccess: data => {
			snackbar.success('Otp sent on mobile!');
			if (!showPhoneOtpModal) {
				setShowPhoneOtpModal(true);
			}
			setShowUpdatePhoneModal(false);
		},
		onError: error => {
			const e = axiosErrorHandler(error);
			if (typeof e === 'object' && 'message' in e) {
				snackbar.error(e.message);
			} else {
				snackbar.error('Something went wrong');
			}
		},
	});
	const { mutate: verifyPhoneOtpMutate, isLoading: verifyPhoneOtpLoading } = useMutation(verifyPhoneOtp, {
		onSuccess: data => {
			snackbar.success('Phone verified successfully!');
			if (showPhoneOtpModal) {
				setShowPhoneOtpModal(false);
			}
			setShowUpdatePhoneModal(false);

			refetchProfile();
		},
		onError: error => {
			const e = axiosErrorHandler(error);
			if (typeof e === 'object' && 'message' in e) {
				snackbar.error(e.message);
			} else {
				snackbar.error('Something went wrong');
			}
		},
	});

	return (
		<Box>
			<OTPModal
				isOpen={showPhoneOtpModal}
				onClose={() => {
					// console.log("clearing timers due to otp modal closed!");
					onOTPModalClose();
				}}
				title={'Phone Verification'}
				primaryText={`Please enter the OTP to verify your phone number`}
				secondaryText={<PhoneEdit handlePhoneEditClick={handlePhoneEditClick} phone={updatedPhone ? updatedPhone : profile?.phoneNumber} />}
				otpLength={6}
				timeGap={60}
				onComplete={value => {
					verifyPhoneOtpMutate({ otp: value });
				}}
				onResendCallback={async () => {
					sendPhoneOtpMutate({ phone: updatedPhone || profile?.phoneNumber || '', domainKey: domainConfig?.key });
				}}
				loading={profileLoading || sendPhoneOtpLoading || verifyPhoneOtpLoading}
				// isClosable={isClosable}
			/>
		</Box>
	);
};

export default OTPVerifyModalV2;
